/**
 * A/B Test: Move "Our razor in action" / "Notre rasoir en Action" above the PDP accordion
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-razor-action-up-test="false" → Control — leave video section where it is
 *   data-elios-razor-action-up-test="true"  → Variant — place it just above the accordion
 *                                            (before "What is ELIOS?" / "Qu'est ce que ELIOS ?")
 *
 * Dev preview: ?elios_razor_action_up_test=b  (or true / 1)
 */
(function () {
  'use strict';

  if (window.__eliosRazorActionUpABTestInit) return;
  window.__eliosRazorActionUpABTestInit = true;

  var BODY_ATTR = 'data-elios-razor-action-up-test';
  var ACTIVE_CLASS = 'elios-razor-action-up-test-b';
  var MOVED_ATTR = 'data-elios-razor-action-moved';
  var ORIG_POS_ATTR = 'data-elios-razor-action-orig-pos';
  var ORIG_BEFORE_ATTR = 'data-elios-razor-action-orig-before';
  var ORIG_AFTER_ATTR = 'data-elios-razor-action-orig-after';

  // EN + FR accordion anchors
  var FIRST_ACCORDION_RE =
    /what\s+is\s+elios|qu['\u2019\u02bc]est\s+ce\s+que\s+elios|comment\s+utiliser|how\s+to\s+use/i;

  var applying = false;
  var settleTimers = [];
  var attrObserver = null;

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('elios_razor_action_up_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function getBodyAttr() {
    if (document.body && document.body.hasAttribute(BODY_ATTR)) {
      return document.body.getAttribute(BODY_ATTR);
    }
    if (document.documentElement && document.documentElement.hasAttribute(BODY_ATTR)) {
      return document.documentElement.getAttribute(BODY_ATTR);
    }
    return null;
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    return isTruthy(getBodyAttr());
  }

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.classList.contains('template-product')) return true;
    return /\/products\//.test(window.location.pathname || '');
  }

  function textOf(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function getAccordionTitleText(details) {
    if (!details) return '';
    var summary = details.querySelector('summary');
    if (!summary) return '';
    return textOf(summary);
  }

  function getAccordionMoveTarget(details) {
    if (!details) return null;
    return (
      details.closest('.product-info__block-item') ||
      details.closest('[data-block-type="collapsible-text"]') ||
      details.closest('.product-info__liquid') ||
      details
    );
  }

  /** First accordion row in the PDP stack (What is ELIOS? / Qu'est ce que ELIOS ?) */
  function findAccordionAnchor() {
    var nodes = document.querySelectorAll(
      '.product-info details.accordion, .accordion-group details.accordion, details.product-info__accordion, details.accordion'
    );

    var firstMatch = null;
    var firstAny = null;

    for (var i = 0; i < nodes.length; i += 1) {
      var details = nodes[i];
      // Skip FAQ page sections outside product-info
      if (!details.closest('.product-info, product-info, .product-info__block-item')) continue;

      var item = getAccordionMoveTarget(details);
      if (!item) continue;
      if (!firstAny) firstAny = item;

      if (FIRST_ACCORDION_RE.test(getAccordionTitleText(details))) {
        firstMatch = item;
        break;
      }
    }

    return firstMatch || firstAny;
  }

  function findVideoSectionItems() {
    var items = [];
    var carousel = document.querySelector(
      '.product-info__block-item--video-carousel, .product-info__block-item .video-carousel-container'
    );
    if (carousel) {
      var card =
        carousel.classList && carousel.classList.contains('product-info__block-item')
          ? carousel
          : carousel.closest('.product-info__block-item');
      if (card && items.indexOf(card) === -1) items.push(card);
    }

    // Circle stories sibling (same UGC section family)
    var stories = document.querySelector('.product-info__block-item--elios-ugc-stories');
    if (stories && items.indexOf(stories) === -1) {
      // Keep relative order: carousel then stories
      items.push(stories);
    }

    // Fallback: heading text match
    if (!items.length) {
      var headings = document.querySelectorAll('.carousel-heading, h2, h3');
      for (var h = 0; h < headings.length; h += 1) {
        var t = textOf(headings[h]);
        if (/our\s+razor\s+in\s+action|notre\s+rasoir\s+en\s+action/i.test(t)) {
          var wrap =
            headings[h].closest('.product-info__block-item') ||
            headings[h].closest('.video-carousel-container') ||
            headings[h].parentElement;
          if (wrap && items.indexOf(wrap) === -1) items.push(wrap);
          break;
        }
      }
    }

    return items;
  }

  function rememberPosition(item) {
    if (!item || item.hasAttribute(ORIG_POS_ATTR)) return;

    var next = item.nextElementSibling;
    var prev = item.previousElementSibling;
    var nextId = next && next.getAttribute('data-block-id');
    var prevId = prev && prev.getAttribute('data-block-id');

    item.setAttribute(ORIG_POS_ATTR, '1');
    if (nextId) item.setAttribute(ORIG_BEFORE_ATTR, nextId);
    if (prevId) item.setAttribute(ORIG_AFTER_ATTR, prevId);
  }

  function findBlockItemById(blockId) {
    if (!blockId) return null;
    return document.querySelector('.product-info__block-item[data-block-id="' + blockId + '"]');
  }

  function restorePosition(item) {
    if (!item || !item.hasAttribute(ORIG_POS_ATTR)) return;

    var beforeId = item.getAttribute(ORIG_BEFORE_ATTR);
    var afterId = item.getAttribute(ORIG_AFTER_ATTR);
    var anchor;

    if (beforeId) {
      anchor = findBlockItemById(beforeId);
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(item, anchor);
        item.removeAttribute(MOVED_ATTR);
        return;
      }
    }

    if (afterId) {
      anchor = findBlockItemById(afterId);
      if (anchor && anchor.parentElement) {
        if (anchor.nextElementSibling) {
          anchor.parentElement.insertBefore(item, anchor.nextElementSibling);
        } else {
          anchor.parentElement.appendChild(item);
        }
        item.removeAttribute(MOVED_ATTR);
      }
    }
  }

  function moveAboveAccordion(items, anchor) {
    if (!items.length || !anchor || !anchor.parentElement) return;

    var parent = anchor.parentElement;
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (!item || item === anchor) continue;
      rememberPosition(item);
      parent.insertBefore(item, anchor);
      item.setAttribute(MOVED_ATTR, 'true');
    }
  }

  function applyMove(active) {
    var items = findVideoSectionItems();
    var anchor = findAccordionAnchor();

    if (active) {
      if (!items.length || !anchor) return false;
      moveAboveAccordion(items, anchor);
      return true;
    }

    for (var i = 0; i < items.length; i += 1) {
      restorePosition(items[i]);
    }
    // Also restore any marked nodes that might not be in find list
    var moved = document.querySelectorAll('[' + MOVED_ATTR + '="true"]');
    for (var m = 0; m < moved.length; m += 1) {
      restorePosition(moved[m]);
    }
    return true;
  }

  function clearSettleTimers() {
    for (var i = 0; i < settleTimers.length; i += 1) {
      window.clearTimeout(settleTimers[i]);
    }
    settleTimers = [];
  }

  function scheduleSettlePasses() {
    clearSettleTimers();
    var delays = [250, 700, 1500, 2800];
    for (var i = 0; i < delays.length; i += 1) {
      (function (ms) {
        settleTimers.push(
          window.setTimeout(function () {
            apply(true);
          }, ms)
        );
      })(delays[i]);
    }
  }

  function apply(fromSettle) {
    if (applying) return;
    applying = true;

    try {
      if (!isProductPage()) {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        if (document.body) document.body.classList.remove(ACTIVE_CLASS);
        return;
      }

      var enabled = isAbEnabled();

      if (document.body) document.body.classList.toggle(ACTIVE_CLASS, enabled);
      document.documentElement.classList.toggle(ACTIVE_CLASS, enabled);

      if (document.body && isDevVariantB() && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }

      applyMove(enabled);
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[elios-razor-action-up-ab]', err);
      }
    } finally {
      applying = false;
    }
  }

  function run() {
    apply(false);
    if (isAbEnabled()) scheduleSettlePasses();
    else clearSettleTimers();
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    run();
    if (!document.body) return;

    // Attribute-only observer — avoids infinite loops from DOM moves
    attrObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var m = mutations[i];
        if (
          m.attributeName === BODY_ATTR ||
          m.attributeName === 'data-gem-variant' ||
          m.attributeName === 'data-gem-test-active'
        ) {
          run();
          return;
        }
      }
    });

    attrObserver.observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    if (document.documentElement) {
      attrObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }

    document.addEventListener('shopify:section:load', run);
  }

  window.EliosRazorActionUpABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      run();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      clearSettleTimers();
      apply(false);
    },
    isActive: isAbEnabled,
    hydrate: run
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
